import React, { useMemo, useState } from "react";

// Мессежийн текстийг зурна. ``` хашилттай хэсгийг КОДЫН БЛОК болгоно.
//
// Хөнгөн зориудаар: гуравдагч талын markdown/highlight сан татахгүй. Чатад
// хэрэгтэй нь зөвхөн код ба энгийн текстийг ялгах, хуулах товч л юм.

const FENCE = /```([a-zA-Z0-9+#-]*)\n?([\s\S]*?)```/g;

/** Текстийг {type:'text'|'code'} хэсгүүдэд хуваана */
function split(text) {
  const out = [];
  let last = 0;
  let m;
  FENCE.lastIndex = 0;
  while ((m = FENCE.exec(text)) !== null) {
    if (m.index > last) out.push({ type: "text", value: text.slice(last, m.index) });
    out.push({ type: "code", lang: m[1] || "", value: m[2].replace(/\n$/, "") });
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push({ type: "text", value: text.slice(last) });
  return out;
}

// Мөрөн доторх `код`-ыг тэмдэглэнэ
const inlineCode = (s, key) =>
  String(s)
    .split(/(`[^`\n]+`)/g)
    .map((part, i) =>
      /^`[^`]+`$/.test(part) ? (
        <code key={`${key}-${i}`} className="chat-inline-code">{part.slice(1, -1)}</code>
      ) : (
        <React.Fragment key={`${key}-${i}`}>{part}</React.Fragment>
      )
    );

const CodeBlock = ({ lang, value }) => {
  const [copied, setCopied] = useState(false);
  const copy = async (e) => {
    // Бөмбөлөг дээр дарахад үйлдлийн цэс нээгддэг — хуулах нь тэрийг нээх ёсгүй
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) { /* clipboard хаалттай байж болно */ }
  };
  return (
    <div className="chat-code" onClick={(e) => e.stopPropagation()} role="presentation">
      <div className="chat-code-bar">
        <span className="chat-code-lang">{lang || "код"}</span>
        <button type="button" className="chat-code-copy" onClick={copy} title="Хуулах">
          <i className={copied ? "ri-check-line" : "ri-file-copy-line"}></i>
          {copied ? " хуулав" : ""}
        </button>
      </div>
      <pre><code>{value}</code></pre>
    </div>
  );
};

const ChatText = ({ text }) => {
  const parts = useMemo(() => split(String(text || "")), [text]);
  return (
    <React.Fragment>
      {parts.map((p, i) =>
        p.type === "code" ? (
          <CodeBlock key={i} lang={p.lang} value={p.value} />
        ) : (
          <div key={i} className="fs-13" style={{ whiteSpace: "pre-wrap" }}>
            {inlineCode(p.value.replace(/^\n+|\n+$/g, ""), i)}
          </div>
        )
      )}
    </React.Fragment>
  );
};

export default ChatText;
